export * from 'src/global/delay';
export * from 'src/global/pageScrollTop';
export * from 'src/global/autoScrollTop';
export * from 'src/global/copyClipboard';
export * from 'src/global/documentLoaded';
export * from 'src/global/navigate';
export * from 'src/global/subscribePushState';
export * from 'src/global/validateEmail';
export function getDate(dateTime) {
    const date = new Date(dateTime);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
export function getDateFormat(date) {
    date = new Date(date);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
}
export function groupTransactionsByDate(transactions) {
    const result = transactions.reduce((result, transaction) => {
        let arr = result[getDate(transaction.createdAt).getTime()];
        if (!arr) {
            result[getDate(transaction.createdAt).getTime()] = arr = [];
        }
        arr.push(transaction);
        return result;
    }, {});
    return Object.values(result);
}
export function numberWithSpaces(number) {
    let parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
}
export function abbreviateNumber(number) {
    if (number < 100000) {
        return number.toString();
    }
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let num = number;
    let suffixIndex = 0;
    while (num >= 1000) {
        num /= 1000;
        suffixIndex++;
    }
    num = Math.round(num * 100) / 100;
    return num + suffixes[suffixIndex];
}
export function arrayToEnum(arr) {
    const enumObj = {};
    arr.forEach((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        enumObj[key] = value;
    });
    return enumObj;
}
